require('../css/main.scss');
require('../css/gallery.scss');
require('photoswipe/style.css');

import PhotoSwipeLightbox from 'photoswipe/lightbox';
import PhotoSwipe from 'photoswipe';

const mobileMenu = require('./func/mobile-menu');

window.addEventListener('DOMContentLoaded', run);

async function run(e) {
    mobileMenu('.c-mobile-menu', '.c-mobile-menu_button');

    const lightbox = new PhotoSwipeLightbox({
        gallery: '#gallery',
        children: 'a',
        pswpModule: PhotoSwipe
    });

    lightbox.init();
}
